const DESKTOP_LOGO_SRC = "https://static.yeyango.com/image/2026/08/22/92ecaf23-26a1-4096-8e84-8b8833a7c50b.png?x-oss-process=image/resize,w_240";
const MOBILE_LOGO_SRC = "https://static.yeyango.com/image/2026/08/22/c9a1da85-8f06-4cea-af8a-beaa89d167b1.png?x-oss-process=image/resize,w_160";

function ResponsiveBrandImage({ className }: { className?: string }) {
  return (
    <picture>
      <source media="(min-width: 761px)" srcSet={DESKTOP_LOGO_SRC} />
      <img className={className} src={MOBILE_LOGO_SRC} alt="" />
    </picture>
  );
}

export function BrandLogo({ compact = false, horizontal = false }: { compact?: boolean; horizontal?: boolean }) {
  return (
    <a className={`brand-logo ${compact ? "brand-logo--compact" : ""} ${horizontal ? "brand-logo--horizontal" : ""}`} href="/" aria-label="野羊电竞首页">
      {horizontal ? (
        <>
          <span className="brand-logo__mark" aria-hidden="true">
            <ResponsiveBrandImage className="brand-logo__mark-image" />
          </span>
          <span className="brand-logo__lockup"><b>野羊电竞</b><small>YEYANG ESPORTS</small></span>
        </>
      ) : <ResponsiveBrandImage />}
    </a>
  );
}
